import styled from 'styled-components'

export const View = styled.div`
  width: 100%;
  min-height: 93.8vh;
`
